(function(){

let observer=null;
let gallery=document.querySelector(".gallery-lock");
let container=document.querySelector(".jps-container");

if(!gallery || !container) return;

function buildGallery(){

    if(observer){
        observer.disconnect();
    }

    document.querySelector(".jps-dots")?.remove();

    let items=[...container.querySelectorAll(".t4s-product__media-item")];

    items=items.filter(item=>{

        return getComputedStyle(item).display!="none";

    });

    if(items.length==0) return;

    gallery.scrollTop=0;

    if(items.length <= 1){
        return;
    }

    let dots=document.createElement("div");
    dots.className="jps-dots";

    items.forEach((item,index)=>{

        let dot=document.createElement("div");

        dot.className="jps-dot";

        if(index==0){
            dot.classList.add("active");
        }

        dot.onclick=function(){

            // gallery.scrollTo({

            //     top:item.offsetTop,

            //     behavior:"smooth"

            // });

        };

        dots.appendChild(dot);

    });

    document.body.appendChild(dots);

    observer=new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if(!entry.isIntersecting) return;

            let index=items.indexOf(entry.target);

            document.querySelectorAll(".jps-dot").forEach(function(dot){

                dot.classList.remove("active");

            });

            document.querySelectorAll(".jps-dot")[index]?.classList.add("active");

        });

    },{

        root:gallery,

        threshold:0.6

    });

    items.forEach(function(item){

        observer.observe(item);

    });

}

function waitVariantReady(){

    let lastCount = 0;

    let timer = setInterval(function(){

        let count = document.querySelectorAll(
            ".jps-container .t4s-product__media-item"
        );

        count = [...count].filter(el =>
            getComputedStyle(el).display !== "none"
        ).length;

        if(count > 0 && count === lastCount){

            clearInterval(timer);

            buildGallery();

        }

        lastCount = count;

    },100);

}

window.addEventListener("load", waitVariantReady);


const mo=new MutationObserver(function(){

    clearTimeout(window.galleryRefresh);

    window.galleryRefresh=setTimeout(function(){

        buildGallery();

    },150);

});

mo.observe(container,{

    subtree:true,

    attributes:true,

    attributeFilter:["style","class"]

});

// window.addEventListener("wheel",function(e){

//     let rect=gallery.getBoundingClientRect();

//     if(rect.bottom<=0) return;

//     if(rect.top>=window.innerHeight) return;

//     let max=gallery.scrollHeight-gallery.clientHeight;

//     let top=gallery.scrollTop;

//     if(e.deltaY>0){

//         if(top<max){

//             e.preventDefault();

//             gallery.scrollTop+=e.deltaY;

//         }

//     }else{

//         if(top>0){

//             e.preventDefault();

//             gallery.scrollTop+=e.deltaY;

//         }

//     }

// },{passive:false});

// window.addEventListener("wheel", function (e) {
//     const rect = gallery.getBoundingClientRect();

//     if (
//         rect.bottom <= 0 ||
//         rect.top >= window.innerHeight
//     ) {
//         const main = document.querySelector("#MainContent");
//         if (main) {
//             main.classList.remove("is-sticky");
//         }
//         return;
        
//     }

//     const max = gallery.scrollHeight - gallery.clientHeight;
//     const top = gallery.scrollTop;

//     if (max <= 0) return;

//     const delta = e.deltaY;

//     const newGalleryTop = Math.max(
//         0,
//         Math.min(max, top + delta)
//     );

//     gallery.scrollTop = newGalleryTop;

//     window.scrollBy({
//         top: delta * 0.35,
//         behavior: "auto"
//     });

// }, {
//     passive: true
// });

window.addEventListener("wheel", function (e) {

    const main = document.querySelector("#MainContent");
    const rect = gallery.getBoundingClientRect();

    if (
        rect.bottom > 0 &&
        rect.top < window.innerHeight
    ) {
        if (main) {
            main.classList.add("is-sticky");
        }
    } else {
        if (main) {
            main.classList.remove("is-sticky");
        }

        return;
    }

    const max = gallery.scrollHeight - gallery.clientHeight;
    const top = gallery.scrollTop;

    if (max <= 0) return;

    const delta = e.deltaY;

    const newGalleryTop = Math.max(
        0,
        Math.min(max, top + delta)
    );

    gallery.scrollTop = newGalleryTop;

    window.scrollBy({
        top: delta * 0.35,
        behavior: "auto"
    });

}, {
    passive: true
});

function toggleDots(){

    const dots = document.querySelector(".jps-dots");

    if(!dots) return;

    const rect = gallery.getBoundingClientRect();

    const announcement = document.querySelector("#shopify-section-announcement-bar");
    const header = document.querySelector("#shopify-section-header-bottom");

    const offset =
        (announcement ? announcement.offsetHeight : 0) +
        (header ? header.offsetHeight : 0) * 3 + 200;

    if(rect.bottom <= offset || rect.top >= window.innerHeight){

        dots.style.opacity = "0";
        dots.style.pointerEvents = "none";

    }else{

        dots.style.opacity = "1";
        dots.style.pointerEvents = "auto";

    }
}

toggleDots();

window.addEventListener("scroll", toggleDots);
window.addEventListener("resize", toggleDots);

})();